/**
 * This function is in its own file because it is used by the in-app and public early requester
 * and cannot be bundled with any other imports
 */

export const getPreferredLanguage = () => {
  const navigator = window.navigator;
  const preferredLanguage = window.I18N_MANUAL_LANG || (navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '');
  return preferredLanguage.toLowerCase();
};